module.exports = __webpack_public_path__ + "static/media/sardines-kabayaki-lid.ca8355e5.png";